import React from 'react'
import { Loader } from '@reapit/elements'

type InProgressBlockProps = {
    displayLoadingText?: string
}

const InProgressBlock: React.FC<InProgressBlockProps> = ({ displayLoadingText }) => {
  return (
    <>
      <div className='loader'>
        <p className='el-mr5'>{displayLoadingText || 'Loading Details'}</p>
      </div>
    </>
  )
}

export default InProgressBlock